export interface CommentItem {
  id: string;
  animeId: string;
  user: string;
  avatarSeq: string;
  rating: number;
  content: string;
  date: string;
  likes: number;
}

export const commentList: CommentItem[] = [
  {
    id: "c1",
    animeId: "blade-echo",
    user: "明月照沟渠",
    avatarSeq: "avatar-mingyue",
    rating: 5,
    content: "第一集的战斗演出直接封神，分镜的节奏感太强了。凛的成长线也铺得很扎实，不是无脑爽番。",
    date: "2026-10-14",
    likes: 328,
  },
  {
    id: "c2",
    animeId: "blade-echo",
    user: "剑心未老",
    avatarSeq: "avatar-jianxin",
    rating: 5,
    content: "配乐真的绝，和乐器的部分一出来鸡皮疙瘩都起来了。期待第二季把鸣剑的来历讲清楚。",
    date: "2026-10-13",
    likes: 210,
  },
  {
    id: "c3",
    animeId: "blade-echo",
    user: "路人甲",
    avatarSeq: "avatar-lurenjia",
    rating: 4,
    content: "整体很棒，就是中间几集节奏稍微拖了一点。不过瑕不掩瑜，依然是本季度最期待的番。",
    date: "2026-10-11",
    likes: 96,
  },
  {
    id: "c4",
    animeId: "star-voyage",
    user: "造船的猫",
    avatarSeq: "avatar-cat",
    rating: 5,
    content: "世界观构建太用心了，记忆档案那个设定直接把我刀到。科幻外壳下的情感内核才是重点。",
    date: "2026-10-15",
    likes: 402,
  },
  {
    id: "c5",
    animeId: "star-voyage",
    user: "回声收集者",
    avatarSeq: "avatar-echo",
    rating: 4,
    content: "群像塑造得很好，每个人都有自己的动机。就是有些设定信息量太大，需要暂停消化。",
    date: "2026-10-12",
    likes: 158,
  },
  {
    id: "c6",
    animeId: "paper-crane",
    user: "一枕星河",
    avatarSeq: "avatar-star",
    rating: 5,
    content: "哭到停不下来。它不刻意煽情，但每一集都在悄悄积攒情绪，最后一集直接绷不住了。",
    date: "2026-10-12",
    likes: 512,
  },
  {
    id: "c7",
    animeId: "paper-crane",
    user: "橘子汽水",
    avatarSeq: "avatar-orange",
    rating: 5,
    content: "折纸鹤的意象用得太好了，既是叙事节奏也是情感沉淀。年度最佳治愈番没跑了。",
    date: "2026-10-10",
    likes: 289,
  },
  {
    id: "c8",
    animeId: "painted-sky",
    user: "墨色天青",
    avatarSeq: "avatar-mo",
    rating: 5,
    content: "水墨和动画的结合真的惊艳，每一帧都能截图当壁纸。国风动画就该这么做。",
    date: "2026-10-13",
    likes: 376,
  },
  {
    id: "c9",
    animeId: "spirit-eater",
    user: "深夜食堂常客",
    avatarSeq: "avatar-shitang",
    rating: 5,
    content: "美食和战斗结合得很自然，每集都想点外卖。新章主线要来了，期待值拉满。",
    date: "2026-10-15",
    likes: 244,
  },
  {
    id: "c10",
    animeId: "moonlit-lane",
    user: "推理迷小R",
    avatarSeq: "avatar-r",
    rating: 5,
    content: "双线叙事玩得很溜，每集结尾都留钩子。开放式结局虽然意难平，但细想又觉得很合理。",
    date: "2026-08-22",
    likes: 331,
  },
  {
    id: "c11",
    animeId: "echo-garden",
    user: "琴键上的猫",
    avatarSeq: "avatar-piano",
    rating: 5,
    content: "作为音乐生看哭了，演奏部分的细节太真实了。原创曲也一首比一首好听。",
    date: "2026-07-30",
    likes: 267,
  },
  {
    id: "c12",
    animeId: "dragon-chef",
    user: "干饭大王",
    avatarSeq: "avatar-fan",
    rating: 4,
    content: "轻松下饭就完事了，咕噜太可爱了。虽然不是神作，但看着很舒服，适合睡前看。",
    date: "2026-10-11",
    likes: 143,
  },
];